import img01 from "../assets/images/blog/img01.jpg"
import img02 from "../assets/images/blog/img02.jpg"
import img03 from "../assets/images/blog/img03.png"
import img04 from "../assets/images/blog/img04.jpg"
import img05 from "../assets/images/blog/img05.jpg"
import img06 from "../assets/images/blog/img06.jpg"
import img07 from "../assets/images/blog/img07.jpg"
export const DataBlog = [
  
  {
    title: `Intramet, Empresa homologado por SGS`,
    text: `En Noviembre del año 2021, nuestra empresa INTRAMET SRL concluye satisfactoriamente la auditoría de HOMOLOGACIÓN  realizada por SGS DEL PERÚ SAC, a solicitud de VOLVO PERÚ S.A.`,
    img: img02,
    url:`empresa-homologada-por-sgs`,
    fecha:'13 Marzo 2022'
  },
  {
    title: `Generando oportunidades de desarrollo profesional`,
    text: `En marzo del 2022 tuvo lugar “LA IMPOSICIÓN DE CASCOS”, evento que sistematiza el reconocimiento del nivel de profesionalización y compromiso alcanzado por nuestros colaboradores en el área de producción de INTRAMET.`,
    img: img03,
    url:`generando-oportunidades-de-desarrollo-profesional`,
    fecha:'18 Abril 2022'
  },
  {
    title: `Intramet, nuestra historia historia de la fábrica de carrocerías líder en el sur del Perú`,
    text: `En los años 90 Agripino Coyuri consolida su alto grado de experiencia en la fabricaci&oacute;n de carrocer&iacute;as. Se convierte en Jefe de producci&oacute;n y pieza fundamental en la fundaci&oacute;n de Intramet S.A. `,
    img: img01,
    url:`fabrica-de-carrocerias-lider-en-el-sur-del-peru`,
    fecha:'05 Agosto 2021'
  },
  // {
  //   title: `Etapa de emprendimiento`,
  //   text: `Pasar de técnico a jefe y finalmente animarse a emprender fue un camino que se fue dando de forma natural.  `,
  //   img: img04,
  //   url:`etapa-de-emprendimiento`
  // },
  // {
  //   title: `Inicio de la Fábrica de Carrocerías líder del sur del Perú `,
  //   frase:`“Para ser la mejor empresa del sur del Perú no solo tenían que ser los mejores carroceros, tenían que adquirir visión empresarial”`,
  //   text: `El 17 de Julio del 2006, de forma estratégica y aprovechando la coyuntura en el desarrollo y crecimiento del sector, se funda la empresa “INTRAMET S.R.L.” en el rubro de reparación, mantenimiento y fabricación de carrocerías sobre chasis de las marcas más reconocidas tales como: SCANIA y MERCEDES BENZ.`,
  //   img: img05,
  //   url:`inicio-de-la-fabrica-de-carrocerias`
  // },
  // {
  //   title: `Etapa de evolución, tiempo de reinventarse`,
  //   text: `Con el paso de los años cambiaron las expectativas del mercado y no bastaba tener únicamente un vehículo de buena calidad, tenía que tener un diseño tan atractivo como los vehículos importados. `,
  //   img: img06,
  //   url:`etapa-de-evolucion`
  // },
  // {
  //   title: `¿Qué es lo que trae el futuro para Intramet?`,
  //   text: `Somos una empresa que lleva en su ADN el emprendimiento y excelencia.`,
  //   img: img07,
  //   url:`que-es-lo-que-trae-el-futuro-para-intramet`
  // }

]